import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormControl, FormControlProps, FormLabel, Select } from '@tq/ui-components';
import { ComponentWithAs } from '@tq/ui-components/dist/system';
import { useRecoilState } from 'recoil';
import { useSortOptions } from 'api';

import { searchSortState } from 'store';

export const ConsultationSort: ComponentWithAs<'div', FormControlProps> = (props) => {
  const { t } = useTranslation('search_filter');

  const { data } = useSortOptions();

  const [sort, setSort] = useRecoilState(searchSortState);

  return (
    <FormControl {...props}>
      <FormLabel id='sort-by-label'>{t('sort_by_title', 'Sort by')}</FormLabel>
      <Select
        aria-labelledby='sort-by-label'
        data-testid='sort-filter'
        mr={1}
        width='100%'
        value={sort}
        onChange={(value: string) => setSort(+value)}
        menuZIndex={1}
      >
        {data &&
          data?.sortOptions?.map((filter) => (
            <option key={filter.value} value={filter.value}>
              {filter.label}
            </option>
          ))}
      </Select>
    </FormControl>
  );
};
